import Checkbox from '@/app/components/Checkbox';

interface FilterItemProps {
  label: string;
  onClick?: (id: string) => void;
  isActive?: boolean;
  id: string;
}

export const FilterItem = ({ label, onClick, id, isActive }: FilterItemProps) => {
  const handleClick = (e: React.MouseEvent<HTMLLIElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClick?.(id);
  };

  return (
    <li
      onClick={handleClick}
      className="w-full h-full flex items-center justify-start gap-2 p-2 hover:bg-blue-50 cursor-pointer rounded-md"
    >
      <Checkbox checked={isActive} size="small" variant="secondary" type="checkbox" />
      <span className="text-black text-body-regular">{label}</span>
    </li>
  );
};